import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ComplianceFacilityRuleRecord = QueryAtomResult<
  typeof queryComplianceFacilityRulesAtom
>[number];

export const queryComplianceFacilityRulesAtom = createQueryAtomFactory(
  'settings.complianceFacilityRules',
  () => ({
    complianceFacilityRules: {
      __args: {
        pagination: {
          offset: 0,
          limit: 100,
        },
      },
      entries: {
        id: true,
        facilityId: true,
        ruleDefinitionId: true,
        isEnabled: true,
        configuredValue: true,
        applicableCategoryIds: true,
        effectiveFrom: true,
        effectiveTo: true,
        notes: true,
        ruleDefinition: {
          id: true,
          ruleCode: true,
          name: true,
          description: true,
          category: true,
          dataType: true,
          defaultValue: true,
          enforcementLevel: true,
          appliesTo: true,
        },
        facility: {
          id: true,
          facilityName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.complianceFacilityRules.entries.map((rule) => ({
        id: rule.id,
        facilityId: rule.facilityId,
        ruleDefinitionId: rule.ruleDefinitionId,
        isEnabled: rule.isEnabled,
        configuredValue: rule.configuredValue,
        applicableCategoryIds: rule.applicableCategoryIds,
        effectiveFrom: rule.effectiveFrom,
        effectiveTo: rule.effectiveTo,
        notes: rule.notes,
        ruleDefinition: rule.ruleDefinition
          ? {
              id: rule.ruleDefinition.id,
              ruleCode: rule.ruleDefinition.ruleCode,
              name: rule.ruleDefinition.name,
              description: rule.ruleDefinition.description,
              category: rule.ruleDefinition.category,
              dataType: rule.ruleDefinition.dataType,
              defaultValue: rule.ruleDefinition.defaultValue,
              enforcementLevel: rule.ruleDefinition.enforcementLevel,
              appliesTo: rule.ruleDefinition.appliesTo,
            }
          : undefined,
        facilityName: rule.facility?.facilityName,
        createdAt: rule.timestamps.createdAt,
        updatedAt: rule.timestamps.updatedAt,
      })) ?? [],
  },
);
